import { GridCellProps } from '@progress/kendo-react-grid';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
};

const IndexCell = ({ className, e, onClick }: Props) => {
  const data = e.dataItem.index;
  return (
    <td className={className ?? ''}>
      <div>{data}</div>
    </td>
  );
};

export default IndexCell;
